import { GraphyAdminEndpoints } from '@/constants/urls';
import { axiosRubyClient as api } from '@/util/axios/axiosClient';

export type FeatureFlagMap = Record<string, string>;

export const featureFlagsAPI = {
  // Current admin's resolved flag -> variant map from graphy's native A/B
  // feature-flag engine. Returns {} (not a rejection) on a bad/empty payload
  // shape; useFeatureFlag treats a rejected request the same way, defaulting
  // every flag to 'off'.
  me: async (): Promise<FeatureFlagMap> => {
    // axiosRubyClient sets no global timeout (axios default 0 = never), so a
    // hung request here would leave every useFeatureFlag() caller's
    // `loading` stuck true forever (see WorkerTable's staffing-modal-loading
    // dialog fix). A per-request timeout bounds that specifically, without
    // changing behavior for any other axiosRubyClient caller.
    const response = await api.get(GraphyAdminEndpoints.GET_FEATURE_FLAGS_ME, {
      timeout: 10000,
    });
    return (response?.data?.data as FeatureFlagMap) ?? {};
  },
};
